import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Observable } from "rxjs";
import { SocialMediaService } from "./social-media.service";

@Component({
  selector: "app-icon-facebook",
  template: `<a
                href="{{ url | async }}"
                target="_blank"
                class="fa-stack">
                <i class="fa fa-circle fa-stack-1x"></i>
                <i class="fab fa-facebook-f fa-stack-1x"></i>
            </a>`,
  styleUrls: ["./icon-social-media.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconFacebookComponent {

  constructor(
    private readonly socialMediaService: SocialMediaService
  ) { }

  get url(): Observable<string> {
    return this.socialMediaService.facebookUrl$;
  }
}
